import { CalendarOutlined } from '@ant-design/icons';
import { Table } from 'antd/lib';
import moment from 'moment';
import { equals, isNil, prop } from 'ramda';
import React from 'react';
import { Components } from '@fasstech/flexiget';

export const renderDate = (date, tooltip, icon) => {
  if (isNil(date) || equals('0', date)) {
    return;
  }

  return (
    <span className="inline-flex items-center">
      <Components.Tooltip title={tooltip}>
        {icon || <CalendarOutlined className="!text-flexi-primary-color" />}
      </Components.Tooltip>
      &nbsp;{moment(date).format('DD/MM/YYYY HH:mm:ss')}
    </span>
  );
};

export const renderLastUpdate = (
  <Table.Column
    title="Dernière mise à jour"
    dataIndex="dates"
    width={400}
    render={(dates) => dates && renderDate(prop('lastUpdate', dates))}
  />
);
